module.exports = __webpack_public_path__ + "img/illustrations-money.58d5d996.svg";